var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"load-panel load-bg"},[_c('div',{staticClass:"spinner"},[_c('clip-loader',{attrs:{"color":_vm.color,"size":_vm.size}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }